import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';

import { RemoteApiService } from '../core';
import { environment } from '../../environments/environment';
import { Profile } from '../profile/profile-model.service';

export interface UsersApiResult {
    total: number;
    limit: number;
    offset: number;
    profiles: Profile[];
}


@Injectable()
export class UsersSearchService {

    constructor(private remoteApi: RemoteApiService) { }

    findUsers(criteria: string,
        profileAccess: string,
        sortKey: string,
        sortOrder = 'asc',
        pageNumber: number = 0,
        pageSize: number = 10): Observable<UsersApiResult> {

        const parameters: any = {
            offset: pageNumber * pageSize,
            limit: pageSize
        };

        if (criteria) {
            parameters.criteria = criteria;
        }

        if (profileAccess) {
            parameters.profileAccess = profileAccess;
        }

        if (sortKey) {
            parameters.sortKey = sortKey;
        }

        if (sortOrder) {
            parameters.sortOrder = sortOrder;
        }

        return this.remoteApi.getUsers<UsersApiResult>(`/profile/search`, parameters);
    }
}
